

import { call, put, takeEvery } from 'redux-saga/effects'
import { Types, types } from '../../types'
import { getDocument, saveDocument, deleteDocument, getNationalCardCustomerDocumentStatusRequest, deleteDocumentUser } from '../apiRequests/documentRequest'

function* handleGetDocument(action) {
    try {
        const response = yield call(getDocument, action.params)
        yield put({
            type: types.PROFILE_GET_DOCUMEN_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.PROFILE_GET_DOCUMEN_ERROR,
            error: error.response,
        })
    }
}
function* handleSaveDocument(action) {
    try {
        const response = yield call(saveDocument, action.params)
        yield put({
            type: types.PROFILE_SAVE_DOCUMEN_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.PROFILE_SAVE_DOCUMEN_ERROR,
            error: error.response,
        })
    }
}
function* handleDeleteByIdDocument(action) {
    try {
        const response = yield call(deleteDocument, action.params)
        yield put({
            type: types.PROFILE_DELETE_BY_ID_DOCUMENT_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.PROFILE_DELETE_BY_ID_DOCUMENT_ERROR,
            error: error.response,
        })
    }
}

function* getNationalCardCustomerDocumentStatusRequestHandler() {
    try {
        const response = yield call(getNationalCardCustomerDocumentStatusRequest)
        yield put({
            type: Types.GET_NATIONAL_CARD_CUSTOMER_DOCUMENT_STATUS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: Types.GET_NATIONAL_CARD_CUSTOMER_DOCUMENT_STATUS_ERROR,
            error: error.response,
        })
    }
}

function* handleDeleteDocumentUser(action) {
    try {
        const response = yield call(deleteDocumentUser, action.params)
        yield put(
            {
                type: types.PROFILE_DELETE_DOCUMENT_SUCCESS,
                action: response,
            })
    } catch (error) {
        yield put({
            type: types.PROFILE_DELETE_DOCUMENT_ERROR,
            error: error.response,
        })
    }
}


function* watcherDocumentSaga() {
    yield takeEvery(types.PROFILE_GET_DOCUMEN_REQUEST, handleGetDocument)
    yield takeEvery(types.PROFILE_SAVE_DOCUMEN_REQUEST, handleSaveDocument)
    yield takeEvery(types.PROFILE_DELETE_BY_ID_DOCUMENT_REQUEST, handleDeleteByIdDocument)
    yield takeEvery(types.PROFILE_DELETE_DOCUMENT_REQUEST, handleDeleteDocumentUser)
    yield takeEvery(Types.GET_NATIONAL_CARD_CUSTOMER_DOCUMENT_STATUS_REQUEST, getNationalCardCustomerDocumentStatusRequestHandler)


}

export default watcherDocumentSaga